module.exports = __webpack_public_path__ + "banquet/containers/MarketingPricingContainer/images/platforms_2x.d858062e82073f2dd904c120cc9c5b39.jpg";


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingPricingContainer/images/platforms_2x.jpg
// module id = 1719
// module chunks = 1